import qs from 'qs';
import client from './client';

const taxBillUrl = '/api/v1/project/invoice';

// 채권/채무 수금
export const onCollectBuyPay = (dataToSubmit) => {
  return client.put(`${taxBillUrl}/info/${dataToSubmit.invUuid}`, dataToSubmit);
};

//수금/지급 취소
export const onCollectBuyCancle = (invId) => {
  return client.put(`${taxBillUrl}/info/${invId}`, { procCompYn: 'N' });
};
// 결재별 개요 가져오기(trjId, invTyp을 S로 고정함. )
export const getIssuedTaxbillsByApproval = (trjId) => {
  return client.get(`${taxBillUrl}/tran/${trjId}/S/single`);
};

//결재별 세금계산서 내역
export const getIssuedBuyTaxbillsByApproval = (trjId) => {
  return client.get(`${taxBillUrl}/tran/${trjId}/B`);
};

export const getIssuedSalesTaxbillsByApproval = (trjId) => {
  return client.get(`${taxBillUrl}/tran/${trjId}/S`);
};

//프로젝트별 세금계산서 init (S:매출, B:매입)
export const getInitTaxbillByPrj = (prjId, type) => {
  return client.get(`${taxBillUrl}/issue/${prjId}/${type}`);
};

export const getProjectInitBuyTaxbill = (prjId) => {
  return client.get(`${taxBillUrl}/issue/${prjId}/B`);
};

export const getProjectInitSalesTaxbill = (prjId) => {
  return client.get(`${taxBillUrl}/issue/${prjId}/S`);
};

//프로젝트별 세금계산서 init 예정 (S:매출, B:매입)
export const getProjectInitSalesTaxbillPlan = (prjId) => {
  return client.get(`${taxBillUrl}/issue/plan/${prjId}/S`);
};

//프로젝트별 타입별 세금계산서 발행 내역
export const getIssuedBuyTaxbills = (prjId) => {
  return client.get(`${taxBillUrl}/list/${prjId}/B`);
};
export const getIssuedSalesTaxbills = (prjId) => {
  return client.get(`${taxBillUrl}/list/${prjId}/S`);
};

// //세금 매출 취소
// export const onRemoveSales = (prjId,invUuid) => {
//   return client.delete(`${taxBillUrl}/issue/${prjId}/${invUuid}`);
// };

//매출 타입별 세금계산서 발행 내역 삭제

export const removeIssuedTaxbills = (prjId, type, invId) => {
  return client.delete(`${taxBillUrl}/issue/${prjId}/${type}/${invId}`);
};

//프로젝트별 타입별 세금계산서 내역 업데이트
export const addIssuedTaxPlanbill = (prjId, dataToSubmit) => {
  return client.put(`${taxBillUrl}/issue/plan/${prjId}`, dataToSubmit);
};


export const deleteIssuedTaxPlanbill = (prjId, dataToSubmit) => {
  return client.delete(`${taxBillUrl}/issue/plan/${prjId}`, dataToSubmit);
};

//프로젝트별 타입별 세금계산서 발행
export const addIssuedTaxbill = (prjId, dataToSubmit) => {
  return client.post(`${taxBillUrl}/issue/${prjId}`, dataToSubmit);
};

//프로젝트별 세금계산서 리스트 가져오기
export const getTaxbillsByPrj = (prjId) => {
  return client.get(`${taxBillUrl}/list/${prjId}`);
};

//세금계산서 리스트 가져오기
export const getTaxbills = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${taxBillUrl}/list?${queryString}`);
};

//세금 발행 관리
export const getTaxIssued = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${taxBillUrl}/list/request?${queryString}`);
};

//세금계산서 상세보기(id=>invUuid)
export const getTaxbill = (id) => {
  return client.get(`${taxBillUrl}/info/${id}`);
};

//세금계산서 수정
export const editTaxbill = (dataToSubmit) => {
  return client.put(`${taxBillUrl}/info/${dataToSubmit.invUuid}`, dataToSubmit);
};

//계산서 삭제(id=>invUuid)
export const removeTaxbill = (id) => {
  return client.delete(`${taxBillUrl}/info/${id}`);
};

export const getProjectBuyTaxbillPlan = (prjId) => {
  return client.get(`${taxBillUrl}/purchase/plan/${prjId}`);
};

export const postProjectBuyTaxbillPlan = (dataToSubmit) => {
  // 전송되는 데이터에 prjUuid가 포함되어 있으므로 바디에 담아 전송합니다.
  return client.post(`${taxBillUrl}/purchase/plan`, dataToSubmit);
};

